import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=caaeb20e"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=caaeb20e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caaeb20e')) {
      api.createRecord('caaeb20e', component.options)
    } else {
      api.reload('caaeb20e', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=caaeb20e", function () {
      api.rerender('caaeb20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/categories/components/DataForm.vue"
export default component.exports